import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

export const interceptHeader: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const transloco = inject(TranslocoService);
  
  const clonedRequest = request.clone({
    setHeaders: {
      project: 'unipin',
      lang: transloco.getActiveLang()
    }
  });
  return next(clonedRequest);
}
